import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import type { QuotesSearch } from '@/components/quotes/quotes-search-schema'
import { QuotesWorkspace } from '@/components/quotes/quotes-workspace'

export const Route = createFileRoute('/_app/clients/$clientId/soumissions')({
  component: ClientQuotesPage,
})

function ClientQuotesPage() {
  const client = useShellClient()
  const [filters, setFilters] = useState<QuotesSearch>({ page: 1 })
  return (
    <Frame>
      <QuotesWorkspace
        search={filters}
        fixedClient={{ id: client.id, name: client.name }}
        onSearchChange={(next) => {
          setFilters((current) => ({ ...current, ...next }))
        }}
      />
    </Frame>
  )
}
